import { useAbility } from "@casl/react";
import { useMemo } from "react";

import { ActionsForRole } from "@/api/admin/roleManagment";
import { AbilityContext } from "@/services/casl/AbilityProvider";
import type { AbilityAppSections } from "@/types/common";

import type { MenuItem } from "./types";

export const useFilteredAdminMenu = (menu: MenuItem[]) => {
  const ability = useAbility(AbilityContext);

  return useMemo(() => {
    return menu
      .map(item => {
        if (item.children?.length) {
          const children = item.children.filter(child => {
            if (!child.section) return true;

            const sections = Array.isArray(child.section)
              ? child.section
              : [child.section];
            return sections.some(s =>
              ability.can(ActionsForRole.READ, s as AbilityAppSections)
            );
          });

          if (children.length === 0) return null;

          return {
            ...item,
            children,
          };
        }

        if (item.section) {
          const sections = Array.isArray(item.section)
            ? item.section
            : [item.section];

          const hasAccess = sections.some(s =>
            ability.can(ActionsForRole.READ, s as AbilityAppSections)
          );

          return hasAccess ? item : null;
        }

        return item;
      })
      .filter(Boolean) as MenuItem[];
  }, [menu, ability]);
};
